<template>
  <div v-if="isAdmin" class="panel-admin-body">
    <div class="title w-100">{{ title }}</div>
    <div class="container company-list">
      <div class="unique-codes-section border-bottom mt-3">
        <div class="d-flex w-100 flex-column">
          <div class="row">
            <div class="col-lg-2 col-md-12 col-sm-12">
              <div class="w-100 text-center">&nbsp;</div>
              <div class="form-group">
                <label for="filterByClient" class="mr-1 w-100">Client</label>
                <select id="client" name="client" class="custom-select required" v-model="ai_client_search_id" @change="filterClientNameOptions">
                  <option
                      v-for="(client_option, idxClientOptions) in this.client_options"
                      v-bind:value="client_option.value"
                      v-bind:key="idxClientOptions"
                  >
                      {{ client_option.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-2 col-md-12 col-sm-12 ml-auto text-right" hidden="true">
              <div class="w-100 text-center">&nbsp;</div>
              <div class="form-group text-left">
                <label for="filterByClient" class="mr-1 w-100">CACHE</label>
                <div class="show-hide-wrapper" style="width: fit-content;">
                  <span class="cache-label pl-2 pr-2">OFF</span>
                  <toggle v-model="cache" :value="cache" @change="setCacheToggleValue" :sync="true" color="rgb(191, 203, 217)" />
                  <span class="saved-cards-label pl-2 pr-2">ON</span>
                </div>
              </div>
            </div>
          </div>
          <filter-buttons @reset="reset" @filterData="filterData" :is-data-filtering="isDataFiltering" :is-filter-resetting="executeReset"/>
        </div>
      </div>
      <div class="button-container pt-1 pb-1">
        <div class="button-left">
            <div class="pr-2">
                <a href="#" @click="displayDeleteConfirmation(deleteAISalesWizardCacheList,this.aiSalesWizardCacheIdsToDelete,'Delete Match Analysis Cache','Are you sure you want delete the selected match analysis cache list ?')">
                <button type="button" class="btn btn-primary delete-card" id="DeleteAICache" :disabled="!deleteButtonEnabled">
                    Delete Rows 
                    <span class="ml-auto">
                    <font-awesome-icon :icon="['fa', 'minus-circle']" />
                    </span>
                </button>
                </a>
            </div>
        </div>
        <div class="button-right"></div>
      </div>
      <table :id="table.id" :class="table.class" cellspacing="0" width="100%">
        <thead></thead>
        <tbody></tbody>
      </table>
    </div>
  </div>
  <div v-else class="panel-admin-body no-permission-list">You do not have permission to view this page</div>
</template>

<script>
import $ from "jquery";
import Vue from "vue";

import moment from "moment-timezone";
Vue.prototype.moment = moment;

import AdminMixins from "../../mixins/AdminMixins.vue";
import DataTableMixins from "../../mixins/DataTableMixins.vue";
import AdminService from "../../services/admin.service.js";
import AIService from "../../services/ai.service.js";
import FilterButtons from "../../components/filter/FilterButtons.vue";
import FilterMixins from "../../mixins/FilterMixins.vue";

export default {
  name: "AISalesWizardCache",
  mixins: [AdminMixins, DataTableMixins, FilterMixins],
  components: {FilterButtons},
  data() {
    return {
      importCompanyImportFile: "",
      title: "AI Sales Wizard Cache",
      table: {
        id: "ai-sales-wizard-cache-list-table",
        columns: AIService.getAISalesWizardCacheTableColumnData(),
        configuration: {
          searching: true,
          responsive: false,
          dom: 'B<"top"if>rt<"bottom"lp><"clear">',
          paging: true,
          select: true,
          destroy: true,
          info: true,
          ordering: true,
          keys: true,
          bSort: false,
          bSortable: true,
          processing: true,
          columnDefs: [
              {
              targets: 0,       // index of the select-all column
              orderable: false  // disable sorting
              }
          ],
          pageLength: 50,  
        }
      },
      aiSalesWizardCacheIdsToDelete: [],
      needsList: [],
      originalList: [],
      client_options: [],
      ai_client_search_id: 0,
      cache: true,
    };
  },
  methods: {
    async getTableData() {
      this.$root.processServerRequest("Loading table data");
      AIService.getAISalesWizardCacheDataList(this.getTableDataCallback, this);
    },
    getTableDataCallback(response) {
      this.$root.processServerResponse();
      this.originalList = response.data.data;
      this.table.data = this.originalList;
      this.client_options = AIService.buildClientOptionList(this.originalList);
      this.setupTable();
      this.setupRowClick();
      
    },
    setupRowClick() {
      const vm = this;
      const th = $('#ai-sales-wizard-cache-list-table thead').find("th").eq(0);
      th.html('<input type="checkbox" id="select-all" class="text-left ml-0 align-text-bottom"/>');
      if( this.table.dataTable.click == undefined)  {

        this.table.dataTable.on("click", 'input[type="checkbox"]', function(e, dt, type, indexes) {
            var $row = $(this).closest("tr");
            var data = vm.table.dataTable.row($row).data();
            if (!$.isEmptyObject(data)) {
                if (e.target.checked) {
                    if (!vm.aiSalesWizardCacheIdsToDelete.includes(data.aiSalesWizardCacheId)){
                        vm.aiSalesWizardCacheIdsToDelete.push(data.aiSalesWizardCacheId);
                    }
                } else {
                    var match = vm.aiSalesWizardCacheIdsToDelete.find(x => x === data.aiSalesWizardCacheId);
                    if (typeof match !== "undefined") {
                        vm.aiSalesWizardCacheIdsToDelete.splice($.inArray(match, vm.aiSalesWizardCacheIdsToDelete), 1);
                    }
                    $row.removeClass("selected");
                    e.stopPropagation();
                }
            }
        });

        $('#select-all').on('click', function(){
          if ($(this).is( ":checked" )) {
              vm.selectAll();
              // Disable ordering for all columns
              const table = $('#ai-sales-wizard-cache-list-table').DataTable();
              table.columns().every(function () {
                  this.orderable(false);
              });
          } else {
              vm.deselectAll();
              // Re-enable ordering if needed
              const table = $('#ai-sales-wizard-cache-list-table').DataTable();
              table.columns().every(function () {
                  this.orderable(false);
              });
          }
        });
      }
    },
    selectAll: function(){
      let vm = this;
      vm.table.dataTable.rows({ page: 'current' }).every(function(rowIdx){
          var $row = $( this.node() );
          let data = vm.table.dataTable.row($row).data();
          vm.addToDownloadSets(data);
          $row.find('input[name="aiSalesWizardCacheIdToDelete"]').prop('checked', true)
      });
    },
    addToDownloadSets: function(data){
      if (!$.isEmptyObject(data)) {
          this.aiSalesWizardCacheIdsToDelete.push(data.aiSalesWizardCacheId);
      }
    },
    deselectAll: function(){
      this.aiSalesWizardCacheIdsToDelete = [];
      // uncheck all rows in table
      let vm = this;
      // deselect all checkboxes in DOM at once
      $(vm.table.dataTable.rows().nodes()).find('input[name="aiSalesWizardCacheIdToDelete"]').prop('checked', false);
    },
    async deleteAISalesWizardCacheList(result) {
      AIService.deleteAISalesWizardCacheList(this.aiSalesWizardCacheIdsToDelete,this.deleteSalesWizardCacheDataListCallback,this);
    },
    deleteSalesWizardCacheDataListCallback(response) {
        this.$root.processServerResponse();
        let statusCode = response.data.statusCode;
        if (statusCode == 200) {
            AdminService.displaySuccessMessage({ text: response.data.message });
            this.aiSalesWizardCacheIdsToDelete = [];
            this.ai_client_search_id = 0;
            this.getTableData();
        } else {
            AdminService.displayErrorMessage({ text: response.data.message });
        }
    },
    filterData: async function(){
      await this.preFilter();
      let vm = this;
      setTimeout(async () => {
        if(this.ai_client_search_id != 0){
          this.filteredList =  AIService.getAICacheResultsByClient(this.filteredList, this.ai_client_search_id);
        }
        vm.table.data = vm.filteredList;
        vm.setupTable();
        vm.postFilter();
      }, 200);
    },
    reset(){
      this.table.data = this.originalList;
      this.client_options = AIService.buildClientOptionList(this.originalList);
      this.ai_client_search_id = 0;
      this.table.configuration.order = this.tableSortBy;
      this.setupTable();
      this.setupRowClick();
    },
    // setCacheToggleValue(val) {
    //   AIService.saveAICacheToggleValue(val, "matchProfileAnalysisCache", this.saveAICacheToggleValueCallback,this);
    // },
    saveAICacheToggleValueCallback(response) {
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
          AdminService.displaySuccessMessage({ text: response.data.message });
      } else {
          AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    // loadCacheToggleValue() {
    //   AIService.getAICacheToggleValue("matchProfileAnalysisCache", this.loadCacheToggleValueCallback, this);
    // },
    // loadCacheToggleValueCallback(response) {
    //   this.$root.processServerResponse();
    //   if (response.data.statusCode == 200) {
    //     this.cache = response.data.data;
    //   } else {
    //     AdminService.displayErrorMessage({ text: response.data.message });
    //   }
    // },
  },
  computed: {
    deleteButtonEnabled: function(){
        return this.aiSalesWizardCacheIdsToDelete.length > 0;
    },
  },
  created() {
    if (this.isAdmin) {
      this.getTableData();
      // this.loadCacheToggleValue();
      this.table.configuration.order = [[1, "desc"]];
    }
  },
  props: {},
  mounted() {}
};
</script>
